import ContactUsPage from './lib/Pages/ContactUsPage';
import CustomerCarePage from './lib/Pages/CustomerCarePage';
import ReportProblemPage from './lib/Pages/ReportReplomPage';
import WajeezCustomersPage from './lib/Pages/WajeezCustomersPage';
export * from './lib/index';

export {
  WajeezCustomersPage,
  ContactUsPage,
  ReportProblemPage,
  CustomerCarePage,
};
